export const numeric = {

	bind: function (el, binding) {

		let isIban = binding.value == 'iban';
		let isMoney = binding.value == 'money';

		if (!binding.value) return;

		// mac'te comment tuşu 91 

		let handler = e => {
			if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl+A
				(e.keyCode === 65 && (e.ctrlKey === true || e.ctrlKey === 91)) ||
				// Allow: Ctrl+C
				(e.keyCode === 67 && (e.ctrlKey === true || e.ctrlKey === 91)) ||
				// Allow: Ctrl+X
				(e.keyCode === 88 && (e.ctrlKey === true || e.ctrlKey === 91)) ||
				// Allow: Ctrl+V
				(e.keyCode === 86 && (e.ctrlKey === true || e.ctrlKey === 91)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				// let it happen, don't do anything
				return
			}
			// Ensure that it is a number and stop the keypress
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault()
			}

		}

		let makeIban = (val) => {

			let _val = `TR${val}`;
			let __val = _val.split('');

			let arr = [];

			for (let i = 0; i < __val.length; i++) {
				arr.push(__val[i]);
				if ((i + 1) % 4 == 0) arr.push(' ');
			}

			if (arr[arr.length - 1] == ' ') arr.pop();

			return arr.join('');
		}

		let clear = e => {
			if (isMoney) return;

			e.target.value = e.target.value.replace(/\D/g, '');

			if (isIban) e.target.value = makeIban(e.target.value)
		}

		el.onlyNumeric = handler;
		el.cleanNunNumeric = clear;

		el.addEventListener('keydown', handler);
		el.addEventListener('keyup', clear);

	},
	unbind: function (el) {
		el.removeEventListener("keydown", el.onlyNumeric);
		el.removeEventListener("keyup", el.cleanNunNumeric);
	}
}